/**
 * @fileoverview GET handler for the "/engagement/ios_notification_groups" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementIosNotificationGroups } from "./constants";
import type { GetIosNotificationGroupsResult } from "./types";

export const getIosNotificationGroups = reactQueryFetcherAdapter(
  engagementIosNotificationGroups,
  (signal: AbortSignal): Promise<GetIosNotificationGroupsResult> => {
    return fetch("/engagement/ios_notification_groups", "GET", {}, { signal });
  }
);
